import React from 'react';
import { Chip } from '@keplerco/core';
import styles from './assessment-configuration.module.css';
import classNames from 'classnames';
import { SkeletonOverlay } from '../../../../../components/general/loading-state/skeleton-overlay';
import { AssessmentOverviewResponse, PeerOverviewResponse } from '../../../../../models/overmind/assessment-analytics';
import { AssessmentSubType } from '../../../../../enums/assessment-type';

const CUSTOM_THEME = { backgroundColor: 'background', borderColor: 'baby-blue', color: 'text' };

export function AssessmentConfigurationWidget({ isLoading, overviewData, ratingOverview }: { isLoading: boolean; overviewData: AssessmentOverviewResponse; ratingOverview: PeerOverviewResponse | undefined }): JSX.Element {
  return (
    <SkeletonOverlay isLoading={isLoading} width="100%" height="100%">
      <div className={classNames('card', styles.card)}>
        <div className={styles.chips}>
          {(overviewData.assessmentSubType === AssessmentSubType.FOPAssessment || overviewData.assessmentSubType === AssessmentSubType.QuestionnaireAssessment) && <Chip customTheme={CUSTOM_THEME}>{overviewData.allowReassessment ? 'Multiple attempts' : 'Single attempt'}</Chip>}

          <Chip customTheme={CUSTOM_THEME}>{overviewData.forced ? 'Blocked progress' : 'Flexible completion'}</Chip>

          {!!ratingOverview && (
            <React.Fragment>
              {ratingOverview.isSkillsFeedbackEnabled && <Chip customTheme={CUSTOM_THEME}>Open-ended feedback</Chip>}
              {ratingOverview.isAnonymous && <Chip customTheme={CUSTOM_THEME}>Anonymous feedback</Chip>}
            </React.Fragment>
          )}
        </div>

        <div>Configuration</div>
      </div>
    </SkeletonOverlay>
  );
}
